import styled from 'styled-components/macro';
import Button from '../Button';

const SubmitButton = styled(Button)`
  align-self: flex-end;
`;

export default SubmitButton;
